import TieredPricing from 'shared-assets/lib/sdk/tieredPricing';
import Products from 'shared-assets/lib/sdk/products';
import ThemeController from 'shared-assets/lib/utils/controllers/ThemeController';

(function () {
  angular
    .module('kareo.ui.shared.directives.user.k-edit-user-view', [
      'kareo.ui.shared.modules.api.provider.k-provider-service',
      'kareo.ui.shared.directives.validation.input-group',
      'kareo.ui.shared.directives.templates',
      'kareo.ui.shared.directives.ui-mask',
      'kareo.ui.shared.directives.validation.prevent-form-submit',
      'kareo.ui.shared.directives.product.k-product-picker-view',
      'kareo.ui.shared.directives.provider.k-npi-lookup',
      'kareo.ui.shared.directives.provider.k-taxonomy-search',
      'kareo.ui.shared.directives.provider.k-provider-types',
      'kareo.ui.shared.directives.user.k-user-practice-select-view',
      'kareo.ui.shared.directives.user.k-user-practice-select-view2',
      'kareo.ui.shared.directives.user.k-user-profile-photo-view',
      'kareo.ui.shared.directives.user.k-user-roles-select-view',
      'kareo.ui.shared.directives.user.k-user-roles-table-view',
      'kareo.ui.shared.directives.user.k-user-type-view',
      'kareo.ui.shared.directives.user.k-password-requirements',
      'kareo.ui.shared.directives.validation.k-valid-email',
      'kareo.ui.shared.directives.validation.k-unique-user-email',
      'kareo.ui.shared.directives.validation.k-valid-password',
      'kareo.ui.shared.modules.authentication.k-roles',
      'kareo.ui.shared.modules.regex.ssn-regex',
      'kareo.ui.shared.directives.k-constants',
      'ngCookies',
    ])
    .component('kEditUserView', {
      bindings: {
        disabledRoles: '<?', // array of K_ROLE, or object map {K_ROLE : bool}
        kareoSpecialties: '<',
        onCancel: '&',
        onDelete: '&', // this will also be called for onDelete if onLock is not specified
        onLock: '&?',
        onSave: '&',
        currentPractice: '<?',
        practices: '<?',
        providerSpecialties: '<',
        showProductConfirmationModal: '<?', // boolean, default false
        user: '=',
        visibleProducts: '<?', // map {PRODUCT_NAME: {isEnabled: boolean}}
        providersRequireProducts: '<?',
        allowTelehealth: '<?',
        isInSetup: '<?',
        loggedInUser: '<?',
        onFulfillSubscription: '&?',
        editionSetId: '<',
        isCurrentUser: '<',
        allowProviderFields: '<?',
        hasProviderShellsPending: '<?',
        nonProviderUsers: '<?',
        getNonProviderUsers: '&?',
        getClaimingUserByGuid: "&?",
      },
      controller,
      controllerAs: 'vm',
      template: require('./k-edit-user-view.pug')()
    })
    .controller('ThemeController', ThemeController);

  const SUPERVISING_PROVIDERTYPEID = 11;

  controller.$inject = ['$scope', 'K_ROLES', 'SSN_REGEX', 'featureSet', 'providerService', 'KAREO_PLATFORM_EDITIONSET', 'BILLCO_PLATFORM_EDITIONSET', 'kProviderTypeService'];
  function controller($scope, K_ROLES, SSN_REGEX, featureSet, providerService, KAREO_PLATFORM_EDITIONSET, BILLCO_PLATFORM_EDITIONSET, kProviderTypeService) {
    const vm = this;

    vm.addedProducts = {};
    vm.hasExistingProduct = false;
    vm.hasProviderType = false;
    vm.hiddenRoles = [K_ROLES.PHYSICIAN_ASSISTANT];
    vm.isDeleteConfirmed = false;
    vm.removeUserModal = false;
    vm.isEditMode = false;
    vm.isEditingProvider = false;
    vm.isLicenseConfirmationModalOpen = false;
    vm.isProductAdditionConfirmed = false;
    vm.isRolesModalOpen = false;
    vm.numAddedProducts = 0;
    vm.selectedPractices = [];
    vm.selectedPracticesV2 = new Set();
    vm.isBillingSelected = false;
    vm.updateProviderTypes = false;
    vm.supervisingProviderFeatureEnabled = false;
    vm.isInvoicingWarningVisible = false;
    vm.productsReadOnly = false;
    vm.isProviderTypeBlocked = false;
    vm.areProviderFieldsReadOnly = false;
    vm.showUnassignUserModal = false;
    vm.showPracticeListChangeModal = false;
    vm.confirmedPracticeListChange = false;
    vm.isProviderShell = false;
    vm.showClaimSubscription = false;
    vm.providerShellBackup = {};
    vm.practiceAccessDelta = { 
      'addedPractices': [],
      'removedPractices': [],
    };
    vm.additionalProductKeys = ['AI_NOTE_ASSIST'];
    vm.mainProducts = [];
    vm.additionalProducts = [];

    vm.ssnPattern = SSN_REGEX;

    vm.closeConfirmationModal = closeConfirmationModal;
    vm.closePracticeListChangeModal = closePracticeListChangeModal;
    vm.closeUnassignUserModal = closeUnassignUserModal;
    vm.confirmProductAddition = confirmProductAddition;
    vm.imageUpdated = imageUpdated;
    vm.save = save;
    vm.selectTaxonomy = selectTaxonomy;
    vm.submitRemoveUserModal = submitRemoveUserModal;
    vm.updateFromNpi = updateFromNpi;
    vm.updateProductSelected = updateProductSelected;
    vm.checkDegreeField = checkDegreeField;
    vm.isProductRequired = isProductRequired;
    vm.prepareClaimSubscription = prepareClaimSubscription;
    vm.cancelClaimSubscription = cancelClaimSubscription;

    vm.$onInit = init;
    vm.onUserTypeChanged = onUserTypeChanged;
    vm.onProviderTypeChanged = onProviderTypeChanged;

    // ------------------------------------------------------------------------

    function init() {
      $scope.$watch('vm.user.providerInfo.providerTypeId', providerTypeChanged);
      
      vm.isEditMode = !!vm.user.userGuid || (!!vm.user.isProvider && !!vm.user.providerInfo.providerGuid);
      vm.isEditingProvider = vm.isEditMode && !!vm.user.isProvider;
      // If a provider, is it referenced anywhere and can the user type be changed
      vm.isProviderReferenced = vm.user.providerInfo ? vm.user.providerInfo.isProviderReferenced : false;
      vm.currentPracticeGuid = vm.currentPractice ? vm.currentPractice.practiceGuid : '';
      vm.currentPractice = vm.currentPractice || {};
      vm.practices = vm.practices || [];
      vm.showPracticeAccess = !!vm.showPracticeAccess;
      vm.showProductConfirmationModal = !!vm.showProductConfirmationModal;
      vm.visibleProducts = vm.visibleProducts || {};
      vm.isEmergencyUserVisible = false;
      vm.supervisingProviderFeatureEnabled = false;
      vm.isMultiKIdUserValidation = false;
      vm.isNewPracticeListFTEnabled = false;
      vm.isFullOrderProvisionFTEnabled = false;
      vm.isTieredPricing = false;
      vm.isTebraPackage = false;
      vm.isClaimingSubscription = false;
      vm.isClinicalSupervisorRoleFTEnabled = false;
      vm.allowUserTypeSelection = true;
      // The regular expression condition is used to validate texts like this "{1029-1}", because it is a temporal last name for the provider shells
      vm.isProviderShell = !!vm.user.email && vm.user.email.includes("@providerShell.com") && (vm.user.lastName === "{}" || vm.user.lastName.match(/\{\d+-\d+\}/));
      if(vm.isProviderShell) {
        vm.user.firstName = '';
        vm.user.lastName = '';
        vm.user.email = '';
        vm.providerShellBackup = angular.copy(vm.user);
        if(!vm.nonProviderUsers && !!vm.getNonProviderUsers) {
          vm.getNonProviderUsers().then(response => { 
            vm.nonProviderUsers = response.items; 
            initClaimSubscription();
            $scope.$apply();
          });
        }
        else {
          initClaimSubscription();
        }
      }
      
      featureSet.load().then(features => {
        vm.isEmergencyUserVisible = !!features['dark-feature.2015cert-emergency-access'];
        vm.supervisingProviderFeatureEnabled = !!features['dark-feature.supervising-provider'];
        vm.isMultiKIdUserValidation = !!features['dark-feature.multi-kid-user-locking'];
        vm.isNewPracticeListFTEnabled = !!features['dark-feature.webapp-edit-user'];
        vm.isFullOrderProvisionFTEnabled = !!features['dark-feature.signup-full-order-provision'];
        vm.isClinicalSupervisorRoleFTEnabled = !!features['dark-feature.clinical-supervisor-role'];
        initDisplayButtons();
      });

      if (angular.isArray(vm.disabledRoles)) {
        vm.disabledRoles.push(K_ROLES.PROVIDER);
      } else if (angular.isObject(vm.disabledRoles)) {
        vm.disabledRoles[K_ROLES.PROVIDER] = true;
      } else {
        vm.disabledRoles = [K_ROLES.PROVIDER];
      }

      vm.providerProducts = vm.user.providerInfo.products;
      vm.preSelectedProducts = angular.copy(vm.providerProducts);

      angular.forEach(vm.preSelectedProducts, (hasProduct) => {
        if (hasProduct === true) {
          vm.hasExistingProduct = true;
        }
      });

      vm.hasProviderType = vm.isEditingProvider &&
          !!vm.user.providerInfo.providerTypeId;
      vm.hasVisibleProducts = false;

      vm.passwordValidationRequirements = [];

      if (Object.keys(vm.visibleProducts).length > 0) {
        vm.hasVisibleProducts = true;
      } else {
        angular.forEach(vm.user.providerInfo.products, (isActive) => {
          if (isActive) {
            vm.hasVisibleProducts = true;
          }
        });
      }

      if ((vm.isEditingProvider || vm.user.isProvider) && vm.user.providerInfo.ssn) {
        formatSSNForView();
      }

      // ensure provider types are refreshed upon initial load when editing
      vm.updateProviderTypes = vm.isEditingProvider;

      initOldUserPracticeList();
      initUserPracticeSet();
      
      // if a product is selected, it's visible (even if not supplied via
      // visibleProducts attribute)
      angular.forEach(vm.user.providerInfo.productStatus, (product, productName) => {
        if (product.isEnabled) {
          vm.visibleProducts[productName] = { isEnabled: true, isPreselected: true };
        }

        if (product.isFrozen) {
          vm.visibleProducts[productName] = (vm.visibleProducts[productName] || {}).isFrozen = true;
        }
      });

      initPreselectedProducts();
      vm.mainProducts = getMainProducts();
      vm.additionalProducts = getAdditionalProducts();
    }

    function initPreselectedProducts(){
      Promise.all([
        TieredPricing.isTieredPricing(vm.editionSetId),
        TieredPricing.isTebraPackage(vm.editionSetId)
      ]).then(async ([isTieredPricing, isTebraPackage]) => {
        vm.productsReadOnly = isTieredPricing || (vm.isInSetup && vm.isFullOrderProvisionFTEnabled && !vm.allowProviderFields) || 
          (isTebraPackage && vm.isClinicalSupervisorRoleFTEnabled && !!vm.user.providerInfo && vm.user.providerInfo.providerTypeId === SUPERVISING_PROVIDERTYPEID);
        vm.isTieredPricing = isTieredPricing;
      
        vm.isTebraPackage = isTebraPackage;

        if (vm.isClinicalSupervisorRoleFTEnabled){
          if (isTieredPricing) {
            if (isTebraPackage) {
              await setPreselectedProducts(!!vm.user.providerInfo && vm.user.providerInfo.providerTypeId !== SUPERVISING_PROVIDERTYPEID);
            } else {
              await setPreselectedProducts(true);
            }
          }

          if (isTebraPackage) {
            vm.allowUserTypeSelection = !vm.user.isProvider;
          }
        } else {
          if (isTieredPricing) {
            await setPreselectedProducts(true);
          }
        }
      });
    }

    function initDisplayButtons() {
      vm.showLockButton = vm.isEditMode && !vm.user.isLocked && !vm.isProviderShell && !vm.isInSetup;
      vm.showUnassignButton = vm.isNewPracticeListFTEnabled && vm.isEditMode && !vm.isInSetup
        && !vm.isEditingProvider && !vm.user.isLocked && !vm.isProviderShell;
      vm.showDeleteButton = !vm.isNewPracticeListFTEnabled && vm.isEditMode && !vm.isInSetup
        && !vm.isEditingProvider && !vm.user.isLocked && !vm.isProviderShell;
      vm.areProviderFieldsReadOnly = vm.isProviderShell || (vm.isInSetup && vm.isFullOrderProvisionFTEnabled && !vm.allowProviderFields);
    }

    function initOldUserPracticeList() {
      // populate user practices for practice select
      angular.forEach(vm.user.practiceAccess, (practiceGuid) => {
        var i, practice;
        for (i = 0; i < vm.practices.length; i++) {
          practice = vm.practices[i];
          if (practiceGuid === practice.practiceGuid) {
            vm.selectedPractices.push(practice);
            break;
          }
        }
      });

      // Add the current practice should automattically be added to the list
      // if it is not already included. The resource will include it on the save, but
      // if it is a new user vm.user.practiceAccess will be empty or nonexistent
      if (!vm.selectedPractices.length) {
        vm.selectedPractices.push(vm.currentPractice);
      }
    }

    function initUserPracticeSet() {
      vm.selectedPracticesV2 = new Set();
      vm.selectedPracticesV2.add(vm.currentPractice.practiceGuid);
      if(Array.isArray(vm?.user?.practiceAccess)) {
        vm.user.practiceAccess.forEach(practiceGuid => vm.selectedPracticesV2.add(practiceGuid));
      }
    }

    function initClaimSubscription() {
      if(vm.isProviderShell && !!vm.nonProviderUsers && vm.nonProviderUsers.length > 0) {
        vm.nonProviderUsers = addFullNames(vm.nonProviderUsers);
        vm.claimingUserGuidSelected = vm.nonProviderUsers[0].userGuid;
        vm.user.claimingUserGuid = vm.nonProviderUsers[0].userGuid;
        vm.user.claimingUserId = vm.nonProviderUsers[0].userId;
        vm.showClaimSubscription = true;
      }
    }

    function providerTypeChanged (val, oldval) {
      var product;
      // supervising providers can only activate clinical
      // we don't decativate already active subscriptions
      // also handle the case of platform bundles
      if(val !== oldval || val === SUPERVISING_PROVIDERTYPEID ){
        if(val === SUPERVISING_PROVIDERTYPEID) {
          for(product in vm.visibleProducts){
            if(product !== 'KAREO_EHR' || (vm.isClinicalSupervisorRoleFTEnabled && vm.isTebraPackage)){ 
              vm.visibleProducts[product].disabledProviderType = true;
              if(!!vm.providerProducts[product] && !vm.preSelectedProducts[product] || (vm.isClinicalSupervisorRoleFTEnabled && vm.isTebraPackage)) {
                vm.providerProducts[product] = false;
              }
            }
          }
        }else{
          if(oldval === SUPERVISING_PROVIDERTYPEID) {
            for(product in vm.visibleProducts){
              if(product !== 'KAREO_EHR' || (vm.isClinicalSupervisorRoleFTEnabled && vm.isTebraPackage)){
                vm.visibleProducts[product].disabledProviderType = false;
                // if we switched away from supervising provider and we are on the platform bundle
                // we should activate the other modules if clinical was going to be activated
                if(isPlatformBundle(vm.editionSetId) && vm.providerProducts['KAREO_EHR'] 
                  && !vm.preSelectedProducts['KAREO_EHR'] && product !== 'KAREO_TELEHEALTH') {
                    vm.providerProducts[product] = true;
                }
              }
            }
          }

          if (vm.isClinicalSupervisorRoleFTEnabled && vm.isTebraPackage) {
            for(product in vm.visibleProducts){
              if(vm.preSelectedProducts[product]) {
                vm.providerProducts[product] = true;
              }
            }
          }
        }
      } else if(!val) {
        // clean up provider type validation when value is empty
        for(product in vm.visibleProducts){
          vm.visibleProducts[product].disabledProviderType = false;
          vm.visibleProducts[product].isPreselected = false;
        }
      }

      // Update productsReadOnly for Tebra 2.0 packages
      if(!!val && vm.isClinicalSupervisorRoleFTEnabled && vm.isTebraPackage && !vm.isTieredPricing) {
        vm.productsReadOnly = val === SUPERVISING_PROVIDERTYPEID;
      }
    }

    function closeConfirmationModal() {
      vm.isLicenseConfirmationModalOpen = false;
    }

    function closePracticeListChangeModal(confirmed) {
      vm.showPracticeListChangeModal = false;
      vm.confirmedPracticeListChange = confirmed;
      confirmed && save();
    }

    function closeUnassignUserModal(confirmed) {
      vm.showUnassignUserModal = false;
      confirmed && vm.onDelete();
    }

    function confirmProductAddition() {
      closeConfirmationModal();
      save();
    }

    function imageUpdated(imageBase64) {
      vm.user.updatedImageBase64 = imageBase64;
    }

    function openConfirmationModal() {
      vm.isLicenseConfirmationModalOpen = true;
    }

    function getPracticesFromGuids(practiceGuidSet){
      return vm.practices.filter(practice => practiceGuidSet.has(practice.practiceGuid));
    }

    function getPracticeAccessDelta(){
      const addedPractices = new Set(vm.selectedPracticesV2);
      const removedPractices = new Set();
      vm.user?.practiceAccess?.forEach(practiceGuid => {
        addedPractices.has(practiceGuid) 
        ? addedPractices.delete(practiceGuid) 
        : removedPractices.add(practiceGuid);
      });
      return { 
        'addedPractices': getPracticesFromGuids(addedPractices),
        'removedPractices': getPracticesFromGuids(removedPractices),
      };
    }

    async function save() {
      if ( vm.user.practiceAccess?.length > 0
        && vm.isNewPracticeListFTEnabled 
        && !vm.confirmedPracticeListChange ) {
        vm.practiceAccessDelta = getPracticeAccessDelta();
        if ( vm.practiceAccessDelta?.addedPractices.length 
          || vm.practiceAccessDelta?.removedPractices.length) {
          vm.showPracticeListChangeModal = true;
          return;
        }
      }

      var mustConfirmProducts = false;
      // only show if enabled and a product has been added
      if (vm.showProductConfirmationModal && !vm.isProductAdditionConfirmed) {
        vm.addedProducts = {};
        vm.numAddedProducts = 0;

        angular.forEach(vm.user.providerInfo.products,
          (isActive, name) => {
            if (isActive && !vm.preSelectedProducts[name]) {
              vm.addedProducts[name] = true;
              vm.numAddedProducts++;
            }
          });

        if (vm.numAddedProducts > 0) {
          mustConfirmProducts = true;
        }
      }

      // subscription claim already transferred the practice access when checked
      if(!vm.isClaimingSubscription) {
        if (vm.isNewPracticeListFTEnabled) {
          vm.user.practiceAccess = [...vm.selectedPracticesV2];
        } else {
          vm.user.practiceAccess = vm.selectedPractices.map((practice) => {
            return practice.practiceGuid;
          });
        }
      }

      if(vm.isProviderShell && vm.isClaimingSubscription && vm.onFulfillSubscription) {
        await vm.onFulfillSubscription();
      } else if (vm.isProviderShell && vm.onEloquaUpsell) {
        await vm.onEloquaUpsell();
      }

      if (mustConfirmProducts) {
        openConfirmationModal();
      } else {
        if ((vm.isEditingProvider || vm.user.isProvider) && vm.user.providerInfo.ssn) {
          formatSSNForSave();
        }
        vm.onSave();
      }
    }

    function selectTaxonomy(taxonomy) {
      vm.user.providerInfo.taxonomyCode = taxonomy.code;

      vm.updateProviderTypes = !!(vm.user.providerInfo.taxonomyCode);
    }

    function updateProductSelected(selected) {
      if(isPlatformBundle(vm.editionSetId) && vm.user.providerInfo.providerTypeId !== SUPERVISING_PROVIDERTYPEID){
        for( var product in vm.visibleProducts) {
          if(selected){
            if(vm.visibleProducts[product].isEnabled 
              && !vm.visibleProducts[product].isFrozen
              && product !== "KAREO_TELEHEALTH" ){
              vm.providerProducts[product] = true;
            }
          }else{
            if(vm.providerProducts[product] && !vm.preSelectedProducts[product] && product !== "KAREO_TELEHEALTH"){
              vm.providerProducts[product] = false;
            }
          }
        }
      }

      vm.isBillingSelected = (vm.user.providerInfo.products.PM ||
                                vm.user.providerInfo.products.KMB ||
                                vm.user.providerInfo.products.RCM) || false;

      vm.updateProviderTypes = !!(vm.user.providerInfo.taxonomyCode);
    }

    function submitRemoveUserModal() {
      if (vm.removeUserModal == 'Lock') {
        vm.onLock();
      } else if (vm.removeUserModal == 'Delete') {
        vm.onDelete();
      }
    }

    function formatSSNForSave() {
      vm.user.providerInfo.ssn = vm.user.providerInfo.ssn.replace(/-/g, '');
    }

    function formatSSNForView() {
      vm.user.providerInfo.ssn = vm.user.providerInfo.ssn.substring(0, 3) + '-' +
        vm.user.providerInfo.ssn.substring(3, 5) + '-' + vm.user.providerInfo.ssn.substring(5);
    }

    function updateFromNpi(npiInfo) {
      vm.user.firstName = npiInfo.firstName;
      vm.user.middleName = npiInfo.middleName;
      vm.user.lastName = npiInfo.lastName;
      vm.user.providerInfo.degree = npiInfo.credential;
      vm.user.providerInfo.npi = npiInfo.npi;
      if(vm.isInSetup && vm.isFullOrderProvisionFTEnabled && vm.areProviderFieldsReadOnly) {
        if(!!npiInfo.kareoSpecialtyId) {
          vm.user.providerInfo.specialtyId = npiInfo.kareoSpecialtyId;
        }
        if(npiInfo.taxonomyCode && vm.user.providerInfo.taxonomyCode != npiInfo.taxonomyCode) {
          vm.user.providerInfo.taxonomyCode = npiInfo.taxonomyCode;
          vm.isProviderTypeBlocked = true;
        }
      } else {
        vm.user.providerInfo.specialtyId = npiInfo.kareoSpecialtyId;
        vm.user.providerInfo.taxonomyCode = npiInfo.taxonomyCode;
        vm.updateProviderTypes = !!(vm.user.providerInfo.taxonomyCode);
      }

      // Check the degree field that comes back from the npi lookup
      // Some values (8+ characters) are not currently valid because of a database restriction
      vm.checkDegreeField(true);
    }

    function checkDegreeField(npiValidation) {
      // Clear if empty
      if (!vm.user.providerInfo.degree) {
        vm.showNPIDegreeWarning = false;
        vm.showUserInvalidDegree = false;
        return;
      }

      // Temporarily only up to 8 characters allowed because of a database restriction
      // Should be 40 max. Update this when netops makes the db change to update the limit
      vm.showNPIDegreeWarning = vm.user.providerInfo.degree.length > 8 ? npiValidation : false;
      vm.showUserInvalidDegree = !vm.showNPIDegreeWarning && vm.user.providerInfo.degree.length > 8 ? !npiValidation : false;
    }

    function isProductRequired() {
      if (vm.isClinicalSupervisorRoleFTEnabled && vm.isTebraPackage && vm.user.providerInfo.providerTypeId === SUPERVISING_PROVIDERTYPEID){
        return false;
      } else {
        return !!vm.providersRequireProducts && !!vm.user.isProvider && noProductsSelected();
      }
    }

    function cancelClaimSubscription() {
      if(vm.isClaimingSubscription) {
        mapUserInfo(vm.providerShellBackup, vm.user, false);
        vm.user.shellUserGuid = null;
        vm.isClaimingSubscription = false;
      }
      vm.showClaimSubscription = false;
    }

    function prepareClaimSubscription() {
      if(!!vm.getClaimingUserByGuid) {
        vm.user.claimingUserGuid = vm.claimingUserGuidSelected;
        vm.getClaimingUserByGuid().then(response => {
          mapUserInfo(response, vm.user, true);
          vm.user.shellUserGuid = vm.providerShellBackup.userGuid;
          vm.user.claimingUserId = vm.nonProviderUsers.filter(u => u.userGuid == response.userGuid)[0].userId;
          vm.isClaimingSubscription = true;
        });
      }
    }

    function mapUserInfo(fromUser, toUser, mergeRoles) {
        toUser.userId = fromUser.userId;
        toUser.userGuid = fromUser.userGuid;
        toUser.userName = fromUser.userName;
        toUser.firstName = fromUser.firstName;
        toUser.middleName = fromUser.middleName;
        toUser.lastName = fromUser.lastName;
        toUser.gender = fromUser.gender;
        toUser.email = fromUser.email;
        toUser.password = fromUser.password;
        toUser.hidden = fromUser.hidden;
        toUser.createdAt = fromUser.createdAt;
        toUser.updatedAt = fromUser.updatedAt;
        toUser.phoneNumber = fromUser.phoneNumber;
        toUser.phoneExtension = fromUser.phoneExtension;
        toUser.fax = fromUser.fax;
        toUser.npi = fromUser.npi;
        toUser.dea = fromUser.dea;
        toUser.stateLicense = fromUser.stateLicense;
        toUser.stub = fromUser.stub;
        if(Array.isArray(fromUser.practiceAccess)) {
          toUser.practiceAccess = angular.copy(fromUser.practiceAccess);
        }
        if(mergeRoles && Array.isArray(fromUser.roles)) {
          const toUserRoles = new Set(fromUser.roles.concat(toUser.roles));
          toUser.roles = [...toUserRoles];
        } else if(!mergeRoles && Array.isArray(fromUser.roles)) {
          toUser.roles = angular.copy(fromUser.roles);
        }
    }

    function noProductsSelected() {
      for (var product in vm.providerProducts) {
        if (vm.providerProducts.hasOwnProperty(product) &&
            !!vm.providerProducts[product] === true) {
          return false;
        }
      }

      return true;
    }

    function onUserTypeChanged(isProvider) {
      vm.user.isProvider = isProvider;

      if (vm.isClinicalSupervisorRoleFTEnabled && !isProvider){
        delete vm.user.providerInfo.providerTypeId;
      }

      if (isProvider && !!vm.user.userGuid && (!vm.user.providerInfo || !vm.user.providerInfo.providerGuid)) {
        providerService.getProviderByUserGuid(vm.user.userGuid)
          .then((provider) => {
            if (!!provider) {
              vm.user.providerInfo = provider;
            }
          });
      }
    }

    function onProviderTypeChanged(initialProviderTypeId, newProviderTypeId) {
      vm.isInvoicingWarningVisible =
        !!vm.user.providerInfo &&
        !!vm.user.providerInfo.providerGuid &&
        !!newProviderTypeId &&
        (initialProviderTypeId !== newProviderTypeId);
    }

    function isPlatformBundle(editionSetId){
      return editionSetId === KAREO_PLATFORM_EDITIONSET || editionSetId === BILLCO_PLATFORM_EDITIONSET;
    }

    async function setPreselectedProducts(displayInitialProducts) {
      Products.getPreselectedProductsByEditionType().then(products => {
        if (!!products) {
          products.forEach(productName => {
            if (!!vm.visibleProducts[productName]) {
              vm.visibleProducts[productName] = { isEnabled: true, isPreselected: displayInitialProducts };
            }
            if (displayInitialProducts){
              vm.providerProducts[productName] = true;
            }
            vm.preSelectedProducts[productName] = true;
          });
        }
      });
    }

    function addFullNames(users) {
      return users.map(user => {
        const fullName = getFullName(user);
        return {...user, fullName }; 
      });
    }

    function getFullName(user) {
      let userFullName = '';
      if(!!user) {
        if(!!user.firstName) {
          userFullName += user.firstName + ' ';
        }
        if(!!user.middleName) {
          userFullName += user.middleName + ' ';
        }
        if(!!user.lastName) {
          userFullName += user.lastName;
        }
      }
      return userFullName;
    }

    function getMainProducts() {
      return Object.keys(vm.visibleProducts).filter((productKey) => !vm.additionalProductKeys.includes(productKey));
    }

    function getAdditionalProducts() {
      return Object.keys(vm.visibleProducts).filter((productKey) => {
        return vm.additionalProductKeys.includes(productKey) && vm.visibleProducts[productKey].isPreselected;
      });
    }
  }
})();
